import { useMemo, useState } from 'react';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import { IPhoneContactPresence } from '~/shared';
import { MessengerStages } from '../../models/Messenger';
import { setActiveMessengerState, useLayoutDispatch } from '../../redux';
import { AppBackButton } from '../AppBackButton';
import { AppMessengerPlayerCard } from '../AppMessengerPlayerCard';
import { SearchInput } from '../SearchInput';
import {
	StyledContainer,
	StyledHead,
	StyledPlayersList,
} from './AppMessegerNewDialog.styled';

const AppMessegerNewDialog = () => {
	const dispatch = useLayoutDispatch();
	const [searchInputValue, setSearchInputValue] = useState('');

	const contacts = useObservable(rage.contacts.getContacts()) ?? [];
	const presenceList = useObservable<IPhoneContactPresence[]>(
		rage.messages.getContactsPresence(),
	);

	const filteredContacts = useMemo(() => {
		if (!searchInputValue.trim()) return contacts;
		const q = searchInputValue.trim().toLowerCase();
		return contacts.filter(
			(c) => c.name.toLowerCase().includes(q) || c.phoneNumber.includes(q),
		);
	}, [contacts, searchInputValue]);

	return (
		<div>
			<StyledHead>
				<AppBackButton
					onClick={() =>
						dispatch(setActiveMessengerState(MessengerStages.DIALOGS))
					}
				/>
				<Text>Новое сообщение</Text>
			</StyledHead>
			<StyledContainer>
				<SearchInput
					value={searchInputValue}
					onChange={(value) => setSearchInputValue(value)}
					placeholder="Введите имя игрока"
				/>
				<StyledPlayersList tabIndex={-1}>
					{filteredContacts.map((contact) => (
						<AppMessengerPlayerCard
							key={contact.phoneNumber}
							nickname={contact.name}
							online={presenceList.some(
								(p) => p.phoneNumber === contact.phoneNumber && p.isOnline,
							)}
							favorite={contact.isFavorite}
							phoneNumber={contact.phoneNumber}
						/>
					))}
				</StyledPlayersList>
			</StyledContainer>
		</div>
	);
};

export { AppMessegerNewDialog };
